import { useCallback, useRef, useState } from "react";
import { useOnClickOutside } from "usehooks-ts";
import ArrowIcon from "@/common/images/icons/chevron.svg?react";
import ArrowsIcon from "./images/icons/arrows.svg?react";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";
import CloseIcon from "@/common/images/icons/cross.svg?react";
import { MenuItem } from "@/components/UI/MenuItem";
import CheckIcon from "@/common/images/icons/check.svg?react";
import { useBodyLock } from "@/common/hooks/useBodyLock";
import "./SortBySelect.scss";

export interface IItemList {
  label: string;
  value: string | null;
}

interface IProps {
  label?: string;
  value: string | null;
  list: IItemList[];
  onChange: (value: string | null) => void;
  size?: "m" | "l";
}

export const SortBySelect = ({ label, list, value, onChange, size = "m" }: IProps) => {
  const [isOpen, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const isPhone = useDeviceType() === deviceTypeEnum.PHONE;

  const handleToggle = () => {
    setOpen(prev => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useOnClickOutside(ref as React.RefObject<HTMLDivElement>, handleClose);
  useBodyLock(isOpen && isPhone);

  const handleChange = useCallback((item: IItemList) => {
    if (item.value === value) {
      return;
    }
    onChange(item.value);
    handleToggle();
  }, [onChange, value]);

  const options = list.map(item => {
    return (
      <li key={item.value} className="dropdownItem">
        <MenuItem
          key={item.value}
          title={item.label}
          rightIcon={item.value === value ? CheckIcon : undefined}
          isActive={item.value === value}
          onClick={() => handleChange(item)}
        />
      </li>
    );
  });

  return (
    <div className={`selectWrapper ${isOpen ? "selectWrapperOpened" : ""} ${size === "l" ? "selectWrapperLarge" : ""}`} ref={ref}>
      { label && <label className="label" onClick={handleToggle}>
        { isPhone ? <ArrowsIcon /> : label }
        {!isPhone && <ArrowIcon className={`arrow ${isOpen ? "arrowUp" : ""}`} />}
      </label> }
      <ul className={`dropdown ${isOpen ? "dropdownIsOpen" : ""}`}>
        <li className="popupTitle">
          <span>{label}</span>
          <button className="closeBtn" onClick={handleClose} aria-label={`close ${label}`}><CloseIcon /></button>
        </li>
        { options }
      </ul>
      <div className="overlay" onClick={handleClose} />
    </div>
  );
};
